import {trackOnNextPageImpression} from "@otto-ec/tracking-bct";
import {Logger} from "./logger";

export class TopicPromoNew {

    static init(): void {
        Logger.group("[FT3 promo topicpromo]");
        Logger.count("Topicpromo Invocation");

        const containers = document.querySelectorAll('.promo_topicpromo__card');
        containers.forEach((container: Element) => {
            if (container.getAttribute("data-tracked") !== "true") {
                container.setAttribute("data-tracked", "true");
                this.trackClick(container);
            }
        });

        Logger.groupEnd();
    }

    static trackClick(container: Element): void {
        container.addEventListener("click", () => trackOnNextPageImpression({"promo_Click": ["TopicPromotionLarge"]}));
    }

}
